import { render, staticRenderFns } from "./PersonnelRecordChronicleDataTable.vue?vue&type=template&id=61436c2e"
import script from "./PersonnelRecordChronicleDataTable.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordChronicleDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports